// PA restricted list: the routes and the sidebar rows of `wealth.pa-dealing.restricted-list` (ADR-0027).
import { defineWebFeature } from '@/features/kit';

export default defineWebFeature({
    id: 'wealth.pa-dealing.restricted-list',
    routes: [
        {
            frontend: 'comply',
            path: 'pa-restricted-list',
            lazy: () => import('@/pages/comply/pa-restricted-list/page'),
        },
    ],
    nav: [
        {
            frontend: 'comply',
            key: 'pa-restricted-list',
            label: 'Restricted List',
            href: '/comply/pa-restricted-list',
            icon: 'AlertOctagon',
            group: 'pa-dealing',
            order: 520,
        },
    ],
});
